import { watch, type ComputedRef, type Ref } from 'vue'

import { useCommonModalStore } from '@/stores/commonModalStore'
import { ROUTER_PATHS } from '@/constants/router/paths'
import { inspectionPages } from '@/constants/ui/inspection/common/pagesInfo'
import { useInspectionResultStore } from '@/stores/inspectionResultUpsertStore'
import { executeCalculationOverallResult } from './executeCalculationOverallResult'
import { useRouterUtils } from '@/router/useRouterUtils'

interface ValidationParams {
  validateFlag: Ref<boolean>
  unfilledList: Ref<string[]>
  validationResult: Ref<boolean>
  saveToStoreFlag: Ref<boolean>
}

/**
 * 調査のバリデーション
 * @param params
 * @returns なし
 */
export const inspectionValidation = (params: ValidationParams) => {
  const commonModalStore = useCommonModalStore()
  watch(
    () => params.validateFlag.value,
    async newValue => {
      // validateFlagがtrueの場合、バリデーション実施中のため何もしない
      if (newValue) return
      // 必須項目が未入力の場合は、リストをモーダル表示
      if (params.unfilledList.value.length > 0) {
        const bodyParam = params.unfilledList.value.map(item => `・${item}`).join('<br>')
        commonModalStore.openAlertModal({
          title: '未入力の必須項目があります',
          body: bodyParam,
          okTitle: '閉じる',
          okColor: 'secondary'
        })
        return
      }
      // バリデーション結果がfalseの場合はページ遷移しない
      if (!params.validationResult.value) return
      // ページ遷移前にstoreへの保存処理を実施
      params.saveToStoreFlag.value = true
    }
  )
}

interface Step2SkipConfirmParams {
  currentPageIndex: ComputedRef<number>
  utils: ReturnType<typeof useRouterUtils>
}

/**
 * step2遷移時の確認ダイアログ
 * @param params
 * @returns なし
 */
export const step2SkipConfirmDialog = (params: Step2SkipConfirmParams) => {
  const commonModalStore = useCommonModalStore()
  commonModalStore
    .openConfirmModal({
      title: '確認',
      body: 'Step2調査をスキップしますか？',
      okTitle: 'はい',
      cancelTitle: 'いいえ'
    })
    .then(() => {
      params.utils.transition(ROUTER_PATHS.inspection.root + '/' + ROUTER_PATHS.inspection.result)
    })
    .catch(() => {
      params.utils.transition(inspectionPages[params.currentPageIndex.value + 1].path)
    })
}

/**
 * 総合判定結果を算出しstoreに保存
 * @param なし
 * @returns なし
 */
export const setOverallResult = () => {
  const inspectionResultStore = useInspectionResultStore()
  const overallResult = executeCalculationOverallResult()
  inspectionResultStore.setEmergencyAssessment({
    ...inspectionResultStore.emergencyAssessment,
    overallResult
  })
}
